/* eslint-disable react/jsx-no-undef */
/* eslint-disable react/prop-types */
import { Box, Button, CircularProgress, Divider, Grid, Modal, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { resetIAMFormData, updateStartDate } from '../../redux/user/userActions';

import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { useNavigate } from 'react-router-dom';
import { gridSpacing } from 'store/constant';

const UpdateStartDate = ({ updateStartDate, showModal, onboardedToDashboard, closeModal, resetIAMFormData, error }) => {
  const [open, setOpen] = useState(true);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    advertiserGuid: '',
    startDate: null
  });

  const [errors, setErrors] = useState({
    advertiserGuid: '',
    startDate: ''
  });

  const handleClose = () => {
    setOpen(false);
    // closeModal(false);
    resetIAMFormData();
  };

  const navigate = useNavigate();

  const validateField = (name, value) => {
    let error = '';
    if (name === 'advertiserGuid' && value.trim() === '') {
      error = 'Advertiser Guid is required';
    } else if (name === 'startDate') {
      if (!value || isNaN(new Date(value).getTime())) {
        error = 'Valid start date is required';
      }
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
    validateField(name, value);
  };

  const handleDateChange = (value) => {
    const formatted = value ? dayjs(value).format('YYYY-MM-DD') : '';
    setFormData((prev) => ({
      ...prev,
      startDate: formatted
    }));
    validateField('startDate', formatted);
  };

  const openAdvertiserList = () => {
    navigate('/advertisers', { replace: true });
    setOpen(false);
  };

  const handleStartDate = async () => {
    // Manual validation
    const advertiserGuidError = formData.advertiserGuid.trim() === '' ? 'Advertiser Guid is required' : '';
    const startDateError = !formData.startDate || isNaN(new Date(formData.startDate).getTime()) ? 'Valid start date is required' : '';

    setErrors((prev) => ({
      ...prev,
      advertiserGuid: advertiserGuidError,
      startDate: startDateError
    }));

    if (advertiserGuidError || startDateError) {
      return;
    }

    const formattedData = {
      advertiser_guid: formData.advertiserGuid,
      start_date: formData.startDate
    };
    console.log('loading initialy', loading);
    try {
      setLoading(true);
      console.log('loading after set', loading);
      const response = await updateStartDate(formattedData);
      console.log('updating start date', response);
    } catch (error) {
      console.error('Update failed:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Grid container spacing={gridSpacing}>
        <Grid item lg={2} md={10} sm={8} xs={6}></Grid>
        <Grid item lg={8} md={4} sm={4} xs={6}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Box
                  sx={{
                    textAlign: 'center',
                    mb: 3,
                    p: 2,
                    backgroundColor: '#e8f5e8',
                    borderRadius: 2,
                    border: '1px solid #a5d6a7'
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: 'bold',
                      mb: 1,
                      color: '#2e7d32'
                    }}
                  >
                    Update Campaign Start Date
                  </Typography>
                  {/* <Typography
                    variant="body2"
                    sx={{
                      fontStyle: 'italic',
                      color: '#2e7d32'
                    }}
                  >
                    Modify the start date for an existing campaign
                  </Typography> */}
                </Box>
              </Grid>

              {/* Main Content */}
              <Grid item xs={12}>
                <Box
                  sx={{
                    p: 3,
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                    backgroundColor: 'white',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      mb: 2,
                      fontWeight: 'bold',
                      color: '#2e7d32',
                      borderBottom: '2px solid #2e7d32',
                      pb: 1
                    }}
                  >
                    Campaign Start Date Configuration
                  </Typography>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        name="advertiserGuid"
                        label="Advertiser GUID"
                        value={formData.advertiserGuid}
                        onChange={handleChange}
                        error={!!errors.advertiserGuid}
                        helperText={errors.advertiserGuid || 'Enter the advertiser GUID for the campaign you want to update'}
                        variant="outlined"
                        size="medium"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            minHeight: '56px'
                          }
                        }}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <DatePicker
                        label="Select New Start Date"
                        value={formData.startDate ? dayjs(formData.startDate) : null}
                        onChange={handleDateChange}
                        format="YYYY-MM-DD"
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error: !!errors.startDate,
                            helperText: errors.startDate || 'Choose the new start date for the campaign',
                            variant: 'outlined',
                            size: 'medium',
                            sx: {
                              '& .MuiOutlinedInput-root': {
                                minHeight: '56px'
                              }
                            }
                          }
                        }}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Box
                        sx={{
                          mt: 1,
                          p: 2,
                          backgroundColor: '#e3f2fd',
                          border: '1px solid #bbdefb',
                          borderRadius: 1
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            color: '#1976d2',
                            fontWeight: 'medium',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5
                          }}
                        >
                          ℹ️ Note: Updating the start date will lock the Date Picker, and data will be shown starting from that date. This
                          is a universal change, so please review carefully before proceeding.
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item xs={12}>
                      {/* Updated button styles to match AddUser.js */}
                      {(() => {
                        const buttonStyles = {
                          width: '9em',
                          height: '3em',
                          borderRadius: '30em',
                          fontSize: '15px',
                          fontFamily: 'inherit',
                          border: 'none',
                          position: 'relative',
                          overflow: 'hidden',
                          zIndex: 1,
                          boxShadow: '6px 6px 12px rgb(255, 255, 255), -6px -6px 12px #ffffff',
                          background: '#e8e8e8',
                          cursor: 'pointer',
                          textTransform: 'none',
                          fontWeight: 500,
                          color: '#090909',
                          '&::before': {
                            content: '""',
                            width: 0,
                            height: '3em',
                            borderRadius: '30em',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            backgroundImage: 'linear-gradient(to right, rgb(15, 203, 216) 0%, rgb(71, 154, 249) 100%)',
                            transition: '.5s ease',
                            display: 'block',
                            zIndex: -1
                          },
                          '&:hover::before': {
                            width: '9em'
                          },
                          '&:disabled': {
                            opacity: 0.6,
                            cursor: 'not-allowed'
                          }
                        };

                        const statusIconStyles = {
                          color: '#22ae2d',
                          fontSize: 18
                        };

                        const errorIconStyles = {
                          color: '#e53935',
                          fontSize: 18
                        };

                        return (
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              gap: 2,
                              mt: 3,
                              flexWrap: 'wrap'
                            }}
                          >
                            <Button
                              onClick={() => {
                                openAdvertiserList();
                              }}
                              variant="text"
                              sx={buttonStyles}
                            >
                              Cancel
                            </Button>

                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.5
                              }}
                            >
                              <Button onClick={handleStartDate} variant="text" disabled={loading} sx={buttonStyles}>
                                {loading ? <CircularProgress size={16} color="inherit" /> : 'Update Date'}
                              </Button>
                              {onboardedToDashboard && <CheckCircleIcon sx={statusIconStyles} />}
                              {error && !onboardedToDashboard && <CancelIcon sx={errorIconStyles} />}
                            </Box>
                          </Box>
                        );
                      })()}
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </LocalizationProvider>
        </Grid>
      </Grid>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    onboardedToDashboard: state.userReducer.onboardedToDashboard,
    error: state.userReducer.error
  };
};

const mapDispatchToProps = {
  resetIAMFormData: resetIAMFormData,
  updateStartDate: updateStartDate
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateStartDate);
